import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {LoginComponent} from './login/login.component';
import {AuthValidateComponent} from 'app/auth/auth-validate/auth-validate.component';
import {NotAuthorizedComponent} from './not-authorized/not-authorized.component';
import {LoginAsComponent} from "./login-as/login-as.component";

const routes: Routes = [
  { path: 'login',   component: LoginComponent},
  { path: 'login-as',   component: LoginAsComponent},
  { path: 'auth/validate/:code',   component: AuthValidateComponent},
  { path: 'not-authorized',   component: NotAuthorizedComponent},
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AuthRoutingModule { }



// WEBPACK FOOTER //
// ./src/app/auth/auth-routing.module.ts